var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXpd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.542 0.505859C30.3148 0.252754 39.2511 8.78548 39.4951 19.5586C39.7394 30.3316 31.1981 39.2602 20.4248 39.4951C9.66447 39.7296 0.748685 31.2015 0.504883 20.4414C0.261262 9.6813 8.78208 0.758833 19.542 0.505859Z",
    fill: "url(#paint0_linear_1536_178)",
    stroke: "url(#paint1_linear_1536_178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1313 19.7683C30.4108 19.7728 30.6824 19.7831 30.9097 19.8015C31.1526 19.8212 31.2955 19.8469 31.3491 19.866C31.5712 19.9451 31.8011 20.1405 32.0347 20.4792C32.2658 20.8146 32.4704 21.2472 32.6597 21.7292C32.8485 22.2102 33.0123 22.7149 33.1714 23.1941C33.3262 23.6604 33.4818 24.1198 33.6479 24.4666C34.008 25.2182 33.9358 25.9884 33.5005 26.4275C33.3534 26.5757 33.0247 26.677 32.4927 26.7019C31.9642 26.7267 31.487 26.6775 31.0142 26.6736H31.0103L25.5854 26.6765H25.5845C24.6481 26.6778 23.4907 26.7084 22.5864 26.6609C22.0313 26.2394 21.7721 25.6973 21.9858 25.0535C22.2236 24.3372 22.4712 23.5633 22.7524 22.8982C22.8964 22.5577 23.0227 22.1729 23.145 21.824C23.2714 21.4633 23.3981 21.1253 23.5522 20.8259C23.852 20.2438 24.2166 19.8746 24.8101 19.7888C25.4585 19.7818 26.1069 19.7781 26.7554 19.7751L28.7397 19.7722C29.0186 19.7724 29.5648 19.7593 30.1313 19.7683Z",
    fill: "url(#paint2_linear_1536_178)",
    stroke: "url(#paint3_linear_1536_178)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6765 9.73804C23.2245 9.78315 23.6408 9.91462 23.9226 10.1912V10.1921C24.0848 10.351 24.2208 10.5349 24.324 10.7371L24.325 10.739C24.5132 11.1027 24.9329 12.1422 25.3103 13.2087C25.4972 13.7368 25.6689 14.2599 25.7937 14.6951C25.9257 15.155 25.9842 15.4512 25.9841 15.5642C25.9839 15.8736 25.8626 16.1534 25.6267 16.3875V16.3884C25.5581 16.4564 25.4242 16.5308 25.1951 16.5886C24.9715 16.645 24.6991 16.6745 24.3982 16.6863C23.7618 16.7111 23.1893 16.6574 22.6863 16.655H22.6843L17.5515 16.658H17.5496C16.7417 16.6614 15.984 16.7276 15.2654 16.6765L14.9597 16.6462C14.7032 16.6142 14.5706 16.5666 14.4998 16.4998C14.2381 16.2527 14.0648 15.8338 14.0574 15.447C14.0576 15.4429 14.0587 15.425 14.0642 15.3894C14.0707 15.3472 14.0816 15.2918 14.0974 15.2234C14.1291 15.0862 14.177 14.9123 14.238 14.7097C14.36 14.3051 14.5288 13.808 14.7097 13.3025C15.0737 12.2854 15.4741 11.2715 15.6267 10.9431C15.7426 10.6937 15.8537 10.4941 15.99 10.3523C16.2077 10.1259 16.4067 9.98325 16.6121 9.89233C16.8172 9.80151 17.0551 9.75043 17.366 9.74292L17.365 9.74194L20.9558 9.74097C21.5598 9.74153 22.1071 9.6912 22.6765 9.73804Z",
    fill: "url(#paint4_linear_1536_178)",
    stroke: "url(#paint5_linear_1536_178)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9506 19.7717C13.6725 19.7719 14.4626 19.7099 15.1683 19.8264C15.8586 19.9404 16.2532 20.1905 16.3861 20.6653C16.5072 21.0986 16.7385 21.633 16.973 22.1711C17.2143 22.7247 17.4701 23.3057 17.6693 23.8782C17.8696 24.454 17.9998 24.9851 18.0101 25.4358C18.0203 25.8794 17.9141 26.1959 17.6947 26.4192C17.6347 26.4802 17.5274 26.5453 17.348 26.5969C17.1708 26.6479 16.9539 26.6777 16.7084 26.6917C16.1924 26.7208 15.7053 26.6781 15.2494 26.676H15.2474C14.3284 26.6755 13.3854 26.683 12.4379 26.6897C11.4896 26.6964 10.5363 26.7025 9.59314 26.7014C8.70572 26.7004 7.64679 26.5127 6.92908 26.1516C6.56949 25.9706 6.34906 25.7731 6.24744 25.5872C6.16189 25.4304 6.13135 25.2323 6.2699 24.9358C6.46239 24.5239 6.63941 23.9736 6.81677 23.4192C6.99886 22.85 7.18774 22.2547 7.41345 21.7034C7.6404 21.149 7.89105 20.6732 8.17908 20.3313C8.45731 20.001 8.74292 19.8269 9.05505 19.7913C10.3528 19.7723 11.6507 19.7663 12.9486 19.7717H12.9506Z",
    fill: "url(#paint6_linear_1536_178)",
    stroke: "url(#paint7_linear_1536_178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1536_178",
    x1: 19.9999,
    y1: 40,
    x2: 5.5,
    y2: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653846,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1536_178",
    x1: 19.9999,
    y1: 0,
    x2: 19.9999,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1536_178",
    x1: 27.8936,
    y1: 27.2084,
    x2: 25.8443,
    y2: 19.9593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653846,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1536_178",
    x1: 27.8936,
    y1: 19.2654,
    x2: 27.8936,
    y2: 27.2084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1536_178",
    x1: 20.0209,
    y1: 17.195,
    x2: 17.9501,
    y2: 9.92331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653846,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1536_178",
    x1: 20.0209,
    y1: 9.21851,
    x2: 20.0209,
    y2: 17.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1536_178",
    x1: 12.088,
    y1: 27.2018,
    x2: 10.0203,
    y2: 19.9601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653846,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1536_178",
    x1: 12.088,
    y1: 19.2551,
    x2: 12.088,
    y2: 27.2018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpd);
export default __webpack_public_path__ + "static/media/XPD.484e61415afed766c476b0270dfb7829.svg";
export { ForwardRef as ReactComponent };